import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Approval } from 'api/approval';
import { SpaceTabAPI } from 'api/space';
import { DocumentProvider } from 'components/organisms/document/document-store';
import { CurrentSpaceContext } from 'components/organisms/spaces/context';
import { ApprovalsPaneContext } from 'contexts/approvals-pane';
import { useSpace } from 'data/spaces/hooks';
import { CpModalRoot } from '../../builder-components/tabs/design-tab/theme-variables-wrapper';
import { CpSpaceTabPreview } from './cp-space-tab-preview';

export const CpSpaceTabPage: React.FC = () => {
  const { projectId, spaceId, spaceTabId } =
    useParams<{
      projectId: string;
      spaceId: string;
      spaceTabId: string;
    }>();

  const { data: spaceData } = useSpace(Number(spaceId));

  const [newApprovalData, setNewApprovalData] =
    useState<Partial<Approval> | undefined>();

  useEffect(() => {
    SpaceTabAPI.updateLastSeen(Number(projectId), Number(spaceTabId));
  }, [projectId, spaceTabId]);

  if (!spaceData) {
    return <></>;
  }

  return (
    <CurrentSpaceContext.Provider value={spaceData}>
      <DocumentProvider>
        <ApprovalsPaneContext.Provider
          value={{ newApprovalData, setNewApprovalData }}
        >
          <CpSpaceTabPreview
            projectId={Number(projectId)}
            spaceId={Number(spaceId)}
            spaceTabId={Number(spaceTabId)}
          />
          <CpModalRoot />
        </ApprovalsPaneContext.Provider>
      </DocumentProvider>
    </CurrentSpaceContext.Provider>
  );
};
